import React from 'react';
import { Box, Typography } from '@mui/material';
import { CompareArrows as CompareIcon } from '@mui/icons-material';
import { BioProject, BioDeployment } from '../bioacousticMockData';
import DeploymentComparisonChart from './DeploymentComparisonChart';

interface ProjectDeploymentComparisonSectionProps {
  project: BioProject;
}

const ProjectDeploymentComparisonSection: React.FC<ProjectDeploymentComparisonSectionProps> = ({
  project,
}) => {
  // Aggregate all deployments from all sites
  const allDeployments: BioDeployment[] = project.sites.flatMap((site) => site.deployments);

  return (
    <Box
      id="deployment-comparison-section"
      sx={{
        mb: 6,
        pt: 3,
        borderTop: '1px dashed #2A2A2A',
      }}
    >
      {/* Section Header */}
      <Box sx={{ mb: 2.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
          <Box
            sx={{
              bgcolor: 'rgba(245, 158, 11, 0.12)',
              border: '1px solid rgba(245, 158, 11, 0.3)',
              borderRadius: '4px',
              px: 1,
              py: 0.25,
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
            }}
          >
            <CompareIcon sx={{ fontSize: 13, color: '#F59E0B' }} />
            <Typography sx={{ fontSize: '10px', fontWeight: 800, color: '#F59E0B', letterSpacing: '1px' }}>
              CROSS-SITE ANALYSIS : DEPLOYMENT BENCHMARKING
            </Typography>
          </Box>
        </Box>
        <Typography
          sx={{
            fontSize: '24px',
            fontWeight: 800,
            color: '#FFFFFF',
            letterSpacing: '0.5px',
            textTransform: 'uppercase',
          }}
        >
          Project Deployment Comparative Analysis
        </Typography>
        <Typography sx={{ fontSize: '12px', color: '#666666', mt: 0.25 }}>
          Multi-deployment benchmarking across all {project.sites.length} sites and {allDeployments.length} stations in {project.project_name}
        </Typography>
      </Box>

      {/* Comparison Chart Container */}
      <DeploymentComparisonChart
        project={project}
        deployments={allDeployments}
        height={360}
      />
    </Box>
  );
};

export default ProjectDeploymentComparisonSection;
